'use strict'

import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import conf from '../../config/config'

class Meta extends React.Component {
  render () {
    const pagemeta = this.props.pagemeta
    if (!pagemeta) return null
    const metaData = {
      title: pagemeta.meta.title,
      meta: [{
        name: 'description',
        content: pagemeta.meta.description
      }, {
        name: 'keywords',
        content: pagemeta.meta.keywords
      }, {
        name: 'robots',
        content: 'index,follow'
      }],
      link: [{
        rel: 'canonical',
        href: `${conf.META_CANONICAL_URL}${pagemeta.permalink}`
      }]
    }
    return <Helmet {...metaData} />
  }
}

Meta.propTypes = {
  pagemeta: PropTypes.object
}

export default Meta
